import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityLocalidadesIDELoadFailure,
  entityLocalidadesIDELoadRequest,
  entityLocalidadesIDELoadSuccess
} from './entity-localidades-ide.actions';
import { LocalidadesIDEService } from './entity-localidades-ide.service';
import { LocalidadIDE } from './entity-localidades-ide.model';

@Injectable()
export class LocalidadesIDEEffects {
  // load
  loadRequestLocalidadesIDE = createEffect(() =>
    this.actions$.pipe(
      ofType(entityLocalidadesIDELoadRequest),
      mergeMap((action) =>
        this.localidadesIDEService.getLocalidadesIDE(action.q).pipe(
          map((items) => {
            // a cada item le agrego la propiedad departamento como action.q
            items.forEach((item: LocalidadIDE) => {
              item.departamento = action.q;
            });
            return entityLocalidadesIDELoadSuccess({ items });
          }),
          catchError((error) => of(entityLocalidadesIDELoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private localidadesIDEService: LocalidadesIDEService
  ) {
    this.localidadesIDEService.url = environment.apiIDE;
  }
}
